var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"open":_vm.findModal,"modalData":_vm.modalData},on:{"close":function($event){return _vm.$emit('closeModal')},"save":function($event){return _vm.$emit('closeModal')}},scopedSlots:_vm._u([{key:"modalContent",fn:function(){return [_c('DonateTable',{attrs:{"targetId":_vm.targetId}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }